

import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router from './router'
import {
sync
} from 'vuex-router-sync'
import store from '@/plugins/store'
import Api from './fetch'
import Sdk from '@/plugins/sdk'
import Filter from '@/plugins/filter/index'
import Util from '@/plugins/util/index'
import VeeValidate from '@/plugins/validator'
import VueLazyLoad from 'vue-lazyload'
import burialPoint from '@/plugins/burialPoint/index'
import BackGuide from '@/plugins/backGuide/index'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import CloseDialogsPlugin from 'vux/src/plugins/close-dialogs/index.js'
import BusPlugin from 'vux/src/plugins/bus/index.js'
import DevicePlugin from 'vux/src/plugins/device/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'



Vue.prototype.$api = Api

Vue.prototype.$util = Util
Vue.prototype.$burialPoint = burialPoint

Vue.use(Sdk)
Vue.use(Filter)
Vue.use(VeeValidate)
Vue.use(VueLazyLoad, {
error: require('../static/404.jpg'),
attempt: 1
})
Vue.use(DevicePlugin)
Vue.use(ToastPlugin, {
type: 'text',
width: 'auto'
})
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(WechatPlugin)
Vue.use(BusPlugin)

Vue.use(DatetimePlugin)
Vue.use(BackGuide)
Vue.use(CloseDialogsPlugin, router)


Vue.component('group', Group)
Vue.component('cell', Cell)


FastClick.attach(document.body)




sync(store, router)

Vue.config.productionTip = false


const history = window.sessionStorage
history.removeItem('/')
history.removeItem('count')


history.setItem('/', 0)
let historyCount = history.getItem('count') * 1 || 0
let isPush = false
let endTime = Date.now()
let methods = ['push', 'go', 'replace', 'forward', 'back']

document.addEventListener('touchend', () => {
endTime = Date.now()
})
methods.forEach(key => {
let method = router[key].bind(router)
router[key] = function (...args) {
isPush = true
method.apply(null, args)
}
})

if (Util.getQueryString('dt_from') === 'web' && Util.getQueryString('userId')) {
window.localStorage.setItem('web_userId', Util.getQueryString('userId'));
}

router.beforeEach(function (to, from, next) {

if (from.query.dt_from) {

if (!to.query.dt_from) {
let query = to.query;
query['dt_from'] = from.query['dt_from'];
query['cacheNone'] = from.query['cacheNone'] || 1;
query['cacheClose'] = from.query['cacheClose'] || 1;
query['guide'] = from.query['guide'] || null;

if (from.query['userId']) {
query['userId'] = from.query['userId'];
}

next({
path: to.path,
query: query
})
} else {
next()
}
} else {
next()
}
store.commit('UPDATE_LOADING', {
isLoading: true
})
const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)
const routeToName = to.name


if (to.meta.appTitle && to.meta.appTitle !== '' && routeToName !== 'course.courseShareDetail') {
let titleObj = {
title: to.meta.appTitle
}
Vue.prototype.$sdk.beacon.setTitle(titleObj, function () {})
}
document.title = to.meta.title

if (routeToName === 'error.error500') {
if (from.name !== null) {
history.setItem('ruouteName', from.name)
history.setItem('ruouteQuery', JSON.stringify(from.query))
history.setItem('ruouteParams', JSON.stringify(from.params))
} else {
const historyName = history.getItem('ruouteName')
const historyQuery = JSON.parse(history.getItem('ruouteQuery'))
const historyParams = JSON.parse(history.getItem('ruouteParams'))
if (historyName === null) {
history.removeItem('ruouteName')
history.removeItem('ruouteQuery')
history.removeItem('ruouteParams')
} else {
let obj = {
name: historyName,
query: historyQuery,
params: historyParams
}
router.push(obj)
}
}
} else {
history.removeItem('ruouteName')
history.removeItem('ruouteQuery')
history.removeItem('ruouteParams')
}
if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.commit('UPDATE_DIRECTION', {
direction: 'forward'
})
} else {

if (!isPush && (Date.now() - endTime) < 377) {
store.commit('UPDATE_DIRECTION', {
direction: ''
})
} else {
store.commit('UPDATE_DIRECTION', {
direction: 'reverse'
})
}
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('UPDATE_DIRECTION', {
direction: 'forward'
})
}


if (routeToName === 'course.courseShareDetail') {
history.setItem('wxRouteName', routeToName)

if (/\/http/.test(to.path)) {
let url = to.path.split('http')[1]
window.location.href = `http${url}`
} else {
next()
}
} else {
history.removeItem('wxRouteName')


Vue.prototype.$sdk.beacon.getAccountInfo({}, data => {
window.localStorage.setItem('accountInfo', JSON.stringify(data));
if (data.AID !== 0) {
store.commit('SET_USER_ID', data.AID)
}
if (data.ticket !== '') {
store.commit('SET_USER_TICKETD', data.ticket)
}
if (data.AID !== 0 && data.ticket !== '') {
let pdata = {
login_type: 5,
user_id: data.AID,
ticket: data.ticket,
login_from: ''
}
if (data.app === 'ios') {
pdata['login_from'] = 2
} else {
pdata['login_from'] = 3
}
Vue.prototype.$api.common.managerTicketLogin(pdata, res => {
if (res.code === 0) {
store.commit('SET_USER_INFO', data)
} else {
Vue.$vux.toast.show('登录失败')
}
})
} else {

Vue.prototype.$api.common.managerLogoutLogin(res => {})
}
store.commit('SET_APP', data.app)

if (data.app === 'android') {
Vue.prototype.$sdk.beacon.getVersion().then(function (ver) {
let version = Vue.prototype.$util.judgeVersionEnough('3.3.0', ver);
let option = [];
if (version) {
option = [{
'viewType': 'backButton',
'visibility': 1,
color: '37, 37, 37, 1',
word: '',
position: 'left'
},
{
'viewType': 'titleBar',
color: '255, 255, 255, 1',
position: 'middle'
}
];
} else {
option = [{
'viewType': 'backButton',
'visibility': 1,
color: '255, 255, 255, 1',
word: '',
position: 'left'
},
{
'viewType': 'titleBar',
color: '253, 119, 54, 1',
position: 'middle'
}


];
}
Vue.prototype.$sdk.beacon.setWebViewTitleBar(option, function () {})
});
}
if (/\/http/.test(to.path)) {
let url = to.path.split('http')[1]
window.location.href = `http${url}`
} else {
next()
}
})
}
})

router.afterEach(function (to) {
isPush = false
store.commit('UPDATE_LOADING', {
isLoading: false
})




})

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js